// extracted by mini-css-extract-plugin
module.exports = {"warning":"ForgotPassword_warning__2g8go","wrapper":"ForgotPassword_wrapper__Rw6pm"};